<template>
    <transition>
        <el-dialog :visible.sync="dialogVisible" :show-close="false" :lock-scroll="false">
            <div class="kefuPop">
            <div class="kefuCode">
                <p class="kefu">加入VIP群</p>
                <img :src="config.vipUrl" alt="">
                <p class="desc">打开微信扫一扫 加入VIP群</p>
            </div>
                <div class="close">
                <img class="cursor" @click="dialogVisible = false" src="../src/assets/icon/close.png" alt="">
                </div>
            </div> 
        </el-dialog>
    </transition>
  </template>
   
  <script>
  export default {
    data() {
      return {
        dialogVisible:false
      };
    },
    computed: {
        config(){
            return this.$store.state.config;
        }
    },
    methods: {
      
    }
  };
  </script>
   
  <style lang="less" scoped>
    .kefuPop{
      display: flex;
      justify-content: center;
      .kefuCode{
        width: 460px;
        height: 480px;
        border-radius: 10px;
        background: #FFFFFF;
        text-align: center;
        .kefu{
          color: #152646;
          font-size: 24px;
          margin-top: 66px;
        }
        img{
          width: 200px;
          height: 200px;
          margin: 30px auto 0;
        }
        .desc{
          margin-top: 35px;
          color: #666666;
          font-size: 16px;
        }
      }
      .close{
        width: 36px;
        height: 36px;
        margin-left: 10px;
        border-radius: 50%;
        overflow: hidden;
        img{
          width: 36px;
          height: 36px;
        }
      }
    }
  </style>